import { render } from "./EmployeeSkills.vue?vue&type=template&id=6875ae12"
import script from "./EmployeeSkills.vue?vue&type=script&lang=js"
export * from "./EmployeeSkills.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hr.tomorrow.services/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__